import { render, staticRenderFns } from "./IvfExpenses.vue?vue&type=template&id=e285ea8e&scoped=true"
import script from "./IvfExpenses.vue?vue&type=script&lang=js"
export * from "./IvfExpenses.vue?vue&type=script&lang=js"
import style0 from "./IvfExpenses.vue?vue&type=style&index=0&id=e285ea8e&prod&scoped=true&lang=css"
import style1 from "./IvfExpenses.vue?vue&type=style&index=1&id=e285ea8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e285ea8e",
  null
  
)

export default component.exports